{
    "(save {highestYearlyDiscount}%)": "(uštedi {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} dana besplatno",
    "{amount} off": "Snižena cijena {amount}",
    "{amount} off for first {number} months.": "Snižena cijena {amount} za prvih {number} mjeseci.",
    "{amount} off for first {period}.": "Snižena cijena {amount} za prvih {period}.",
    "{amount} off forever.": "Snižena cijena {amount} zauvijek.",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_few": "",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a {duration}-year {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% popusta",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} više neće primati {newsletterName} newsletter.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} više neće primati e-poštu kada netko odgovori na vaš komentar.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} više neće primati ovaj newsletter.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dana besplatno",
    "{years} years": "",
    "+1 (123) 456-7890": "(+385 1) 234-5678",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Vaš račun",
    "Account details updated successfully": "Podaci računa su uspješno ažurirani",
    "Account settings": "Podešavanje vašeg računa",
    "Add a personal note": "Dodajte osobnu poruku",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Nakon isteka probnog perioda, izvršit će se naplata odabranog plana pretplate. Uvijek možete otkazati pretplatu prije toga.",
    "Already a member?": "Već imate račun?",
    "An error occurred": "Došlo je do greške",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Desila se neočekivana greška. Pokušajte ponovo ili kontaktirajte <a>podršku</a> ako će se greška ponavljati.",
    "Back": "Natrag",
    "Back to Log in": "Natrag na prijavu",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Cancel anytime.": "Otkažite pretplatu bilo kada.",
    "Cancel subscription": "Otkaži pretplatu",
    "Canceled": "",
    "Cancellation reason": "Razlog za otkazivanje",
    "Change": "Izmjena",
    "Change plan": "Promijeni plan",
    "Check spam & promotions folders": "Provjerite mape za spam i promociju",
    "Check with your mail provider": "Provjerite s vašim pružateljem usluge e-pošte",
    "Check your inbox to verify email update": "Provjerite svoju pristiglu poštu kako biste potvrdili promjenu e-pošte",
    "Choose": "Odaberite",
    "Choose a different plan": "Odaberite drugi plan",
    "Choose a plan": "Odaberite plan",
    "Choose a tier": "",
    "Choose your newsletters": "Odaberite vaš newsletter",
    "Click here to retry": "Klikni ovdje za ponovni pokušaj",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Zatvori",
    "Code": "",
    "Comment preferences updated.": "Postavke komentara su ažurirane.",
    "Comments": "Komentari",
    "Complimentary": "Besplatno",
    "Confirm": "Potvrda",
    "Confirm cancellation": "Potvrda otkazivanja pretplate",
    "Confirm subscription": "Potvrda pretplate",
    "Contact support": "Kontaktirajte podršku",
    "Continue": "Nastavite",
    "Continue subscription": "Nastavite pretplatu",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Nije moguće pokrenuti Stripe naplatu",
    "Could not sign in. Login link expired.": "Neuspio pokušaj prijave. Link za prijavu je istekao.",
    "Could not update email! Invalid link.": "Neuspio pokušaj izmjene adrese e-pošte! Neispravan link.",
    "Create a new contact": "Napravite novi kontakt:",
    "Current plan": "Trenutni plan pretplate",
    "Delete account": "Obriši račun",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Niste to namjeravali? Upravljajte vašim računom <button>ovdje</button>.",
    "Don't have an account?": "Nemate račun?",
    "Edit": "Uredi",
    "Email": "E-pošta",
    "Email confirmation link expired.": "",
    "Email it to them now": "",
    "Email newsletter": "Newsletter e-poštom",
    "Email newsletter settings updated": "Postavke newsletter-a su ažurirane",
    "Email preferences": "Postavke e-pošte",
    "Email preferences updated.": "Postavke e-pošte su ažurirane.",
    "Emails": "E-pošta",
    "Emails disabled": "Isključena e-pošta",
    "Ends {offerEndDate}": "Završava {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Unesite svoju email adresu",
    "Enter your name": "Unesite svoje ime",
    "Error": "Greška",
    "Expires {expiryDate}": "Ističe {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Nije moguće otkazati pretplatu, pokušajte ponovno",
    "Failed to log in, please try again": "Prijava nije uspjela, pokušajte ponovno",
    "Failed to log out, please try again": "Odjava nije uspjela, pokušajte ponovno",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Naplata nije uspjela, pokušajte ponovno",
    "Failed to send magic link email": "Slanje magičnog linka nije uspjelo",
    "Failed to send verification email": "Slanje verifikacijske poruke nije uspjelo",
    "Failed to sign up, please try again": "Registracija nije uspjela, pokušajte ponovno",
    "Failed to update account data": "Nije moguće ažurirati podatke računa",
    "Failed to update account details": "Nije moguće ažurirati detalje računa",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Ažuriranje postavki newsletter-a nije uspjelo",
    "Failed to update subscription, please try again": "Ažuriranje pretplate nije uspjelo, pokušajte ponovno",
    "Failed to verify code, please try again": "",
    "Forever": "Zauvijek",
    "Free Trial – Ends {trialEnd}": "Besplatan probni period - završava {trialEnd}",
    "From": "",
    "Get help": "Potražite pomoć",
    "Get in touch for help": "Kontaktirajte nas za pomoć",
    "Get notified when someone replies to your comment": "Budite obaviješteni ako netko odgovori na vaš komentar:",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Ostavite komentar na ovaj post",
    "Help! I'm not receiving emails": "Pomoć! Ne primam e-poštu",
    "Here are a few other sites you may enjoy.": "Ovo su još nekoliko drugih stranica koje bi vam se mogle svidjeti.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Ako je newsletter označen kao neželjena e-pošta, poruka se automatski onemogućuje za tu adresu kako biste bili sigurni da više nećete primati neželjene poruke.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Ako je pritužba na spam bila slučajna ili želite ponovno početi primati e-poštu, možete se ponovno pretplatiti klikom na link na prethodnom ekranu.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Ako otkažete vašu pretplatu sada, zadržat će te pristup do {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Ako imate korporativni ili državni račun e-pošte, obratite se svom IT odjelu i zamolite ih da dopuste primanje e-pošte od {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Link za prijavu je poslan na Vašu adresu e-pošte. Ako poruku niste dobili za 3 minute, provjerite spam folder.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Ako želite ponovno početi primati e-poštu, najbolji sljedeći korak je provjeriti postoje li problemi na vašoj adresi e-pošte, a zatim kliknuti na ponovnu pretplatu na prethodnom ekranu.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Ako ne primate newsletter na adresu e-pošte kojom ste se pretplatili, evo nekoliko stvari koje trebate provjeriti.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Ako ste dovršili sve ove provjere, a još uvijek ne primate e-poštu, možete se obratiti za podršku na {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "U slučaju kontinuiranog neusplešnog slanja newsletter-a na vašu adresu e-pošte, slanje newsletter-a će biti onemogućeno za vaš račun.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "U svom klijentu e-pošte dodajte {senderEmail} na svoj popis kontakata. Ovo signalizira vašem davatelju usluga e-pošte da porukama koje su poslane s ove adrese treba vjerovati.",
    "Invalid email address": "Neispravna email adresa",
    "Invalid verification code": "",
    "Jamie Larson": "Ivana Horvat",
    "jamie@example.com": "ivana@example.com",
    "Less like this": "Manje sadržaja poput ovoga",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Pobrinite se da e-poruke slučajno ne završe u mapi Spam ili Promocije u vašoj pristigloj pošti. Ako jesu, kliknite \"Označi da nije neželjena pošta\" i/ili \"Premjesti u pristiglu poštu\".",
    "Manage": "Upravljanje",
    "Maybe later": "Možda kasnije",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "Registracije sa ovog email domena trenutno nisu dopuštene.",
    "Memberships unavailable, contact the owner for access.": "Pretplate nisu dostupne, kontaktirajte vlasnika za pristup.",
    "month": "mjesec",
    "Monthly": "Mjesečno",
    "More like this": "Više sadržaja kao što je ovaj",
    "More options": "",
    "Name": "Ime i prezime",
    "Need more help? Contact support": "Kontaktirajte nas ako trebate dodatnu pomoć",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Slanje newsletter-a se može onemogućiti na vašem računu iz dva razloga: prethodna e-pošta je označena kao neželjena pošta (spam) ili je pokušaj slanja e-pošte rezultirao trajnim neuspjehom (odbijanje).",
    "No member exists with this e-mail address.": "Korisnik sa ovom email adresom ne postoji.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Ne dobivate e-poštu?",
    "Now check your email!": "Provjerite vašu e-poštu!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Nakon što se ponovno pretplatite, ako i dalje ne vidite e-poštu u svojoj pristigloj pošti, provjerite mapu neželjene pošte. Neki pružatelji usluga e-pošte vode evidenciju prethodnih pritužbi na neželjenu poštu i nastavit će označavati e-poštu. Ako se to dogodi, označite najnoviji newsletter kao \"Nije neželjena pošta\" da biste ga vratili u svoju primarnu pristiglu poštu.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Trajni kvar (odbijanje isporuke)",
    "Phone number": "Broj telefona",
    "Plan": "Plan pretplate",
    "Plan checkout was cancelled.": "Checkout plana pretplate je prekinut.",
    "Plan upgrade was cancelled.": "Nadogradnja plana pretplate je prekinuta.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Molimo vas kontaktirajte {supportAddress} za prilagodbu vaše besplatne pretplate.",
    "Please enter {fieldName}": "Molimo unesite {fieldName}",
    "Please fill in required fields": "Molimo vas da ispunite obvezna polja",
    "Podcasts": "",
    "Re-enable emails": "Ponovo omogući slanje e-pošte",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Preporuke",
    "Redeem your gift": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Obnovi po cijeni {price}",
    "Resume subscription": "",
    "Retry": "Pokušaj opet",
    "Save": "Spremi",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Link za prijavu se šalje...",
    "Sending...": "Slanje...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Pokaži sve",
    "Sign in": "Prijava",
    "Sign out": "Odjava",
    "Sign up": "Registracija",
    "Signup error: Invalid link": "Greška prilikom prijave. Neispravan link",
    "Signups from this email domain are currently restricted.": "Registracija sa ovog email domena trenutno nije dopuštena.",
    "Something went wrong, please try again later.": "Nešto je pošlo po zlu, pokušajte ponovno kasnije.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Trenutno nema dostupnih preporuka.",
    "Sorry, that didn’t work.": "Žao nam je, to nije uspjelo.",
    "Spam complaints": "Pritužbe za neželjenu e-poštu",
    "Start {amount}-day free trial": "Aktiviraj besplatni probni period od {amount} dana",
    "Starting {startDate}": "Početni datum {startDate}",
    "Starting today": "Počinje danas",
    "Submit feedback": "Pošalji povratne informacije",
    "Subscribe": "Pretplati se",
    "Subscribed": "Pretplaćen",
    "Subscription plan updated successfully": "Plan pretplate je uspješno ažuriran",
    "Success": "Uspjeh",
    "Success! Check your email for magic link to sign-in.": "Uspjeh! Provjerite vašu e-poštu i pronađite poruku s linkom za prijavu.",
    "Success! Your account is fully activated, you now have access to all content.": "Uspjeh! Vaš račun je uspješno aktiviran i sada imate pristup svim sadržajima.",
    "Success! Your email is updated.": "Uspjeh! Vaš račun e-pošte je ažuriran.",
    "Successfully unsubscribed": "Uspješna odjava",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Hvala što ste se pretplatili. Prije nego počnete čitati, u nastavku je nekoliko drugih stranica koje bi vam se mogle svidjeti.",
    "Thank you for your support": "Hvala vam na podršci",
    "Thank you for your support!": "Hvala vam na podršci!",
    "Thanks for the feedback!": "Hvala na povratnim informacijama!",
    "That didn't go to plan": "Nešto je pošlo po zlu",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Adresa e-pošte vašeg računa je {memberEmail} - ako to nije točno, možete ga ažurirati u <button>postavkama računa</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Došlo je do problema sa slanjem vaše poruke. Pokušajte ponovno malo kasnije.",
    "There was an error cancelling your subscription, please try again.": "Došlo je do greške prilikom otkazivanja pretplate, pokušajte ponovno.",
    "There was an error continuing your subscription, please try again.": "Došlo je do greške prilikom nastavka pretplate, pokušajte ponovno.",
    "There was an error processing your payment. Please try again.": "Došlo je do greške prilikom obrade uplate. Pokušajte ponovno.",
    "There was an error sending the email, please try again": "Došlo je do greške prilikom slanja poruke e-pošte, pokušajte ponovno",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Ove stranice su samo za članove, kontaktirajte vlasnika kako biste dobili pristup.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Ova stranica trenutno ne prihvaća uplate.",
    "This site only accepts paid members.": "Ova stranica je dostupna samo korisnicima sa plaćenom pretplatom.",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Kliknite na link za završetak registracije. Ako poruku niste dobili za 3 minute, provjerite spam folder!",
    "To continue to stay up to date, subscribe to {publication} below.": "Da biste ostali u toku, pretplatite se na {publication} u nastavku.",
    "Too many attempts try again in {number} days.": "Previše pokušaja, pokušajte ponovno za {number} dana.",
    "Too many attempts try again in {number} hours.": "Previše pokušaja, pokušajte ponovno za {number} sati.",
    "Too many attempts try again in {number} minutes.": "Previše pokušaja, pokušajte ponovno za {number} minuta.",
    "Too many different sign-in attempts, try again in {number} days": "Previše pokušaja prijave, pokušajte ponovno za {number} dana",
    "Too many different sign-in attempts, try again in {number} hours": "Previše pokušaja prijave, pokušajte ponovno za {number} sati",
    "Too many different sign-in attempts, try again in {number} minutes": "Previše pokušaja prijave, pokušajte ponovno za {number} minuta",
    "Too many sign-up attempts, try again later": "Previše pokušaja registracije, pokušajte ponovno kasnije",
    "Try free for {amount} days, then {originalPrice}.": "Probajte besplatno na {amount} dana, zatim {originalPrice}.",
    "Unable to initiate checkout session": "Nije moguće pokrenuti sesiju naplate",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Otključajte pristup svim newsletterima plaćanjem pretplate.",
    "Unsubscribe from all emails": "Otkažite primanje svih poruka e-poštom",
    "Unsubscribed": "Otkazani ste",
    "Unsubscribed from all emails.": "Otkazani ste od svih poruka e-poštom",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Otkazivanjem primanja poruka e-pošte nećete otkazati Vašu pretplatu na {title}",
    "Update": "Ažuriranje",
    "Update your preferences": "Ažurirajte vaše postavke",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Poslali smo vam verifikacijski link, provjerite svoju e-poštu",
    "Verify your email address is correct": "Potvrdite točnost računa vaše e-pošte",
    "Verifying...": "",
    "View plans": "Prikaži sve planove pretplate",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Nismo uspjeli otkazati vašu e-poštu jer je nismo pronašli u sustavu. Molimo vas kontaktirajte vlasnika stranice.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Dobrodošli natrag {name}!",
    "Welcome back!": "Dobrodošli natrag!",
    "Welcome to {siteTitle}": "Dobrodošli na {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Kada vaš email server ne prihvati e-poštu to se obično naziva odbijanje. U mnogim slučajevima to može biti privremeno. Međutim, u nekim slučajevima odbijena e-pošta može se vratiti kao trajna greška kada je adresa e-pošte nevažeća ili nepostojeća.",
    "Why has my email been disabled?": "Zašto je moja adresa e-pošte blokirana?",
    "X (Twitter)": "",
    "year": "godina",
    "Yearly": "Godišnje",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Trenutno ste imate besplatnu pretplatu, odabirom plaćene pretplate dobit ćete pristup svim sadržajima.",
    "You have been successfully resubscribed": "Uspješno ste se ponovo pretplatili",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Trenutno ne primate e-poštu",
    "You're not receiving emails": "Ne primate e-poštu",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Ne primate e-poštu zato što ste nedavnu poruku označili kao nepoželjnu ili zato što se poruke nisu mogle isporučiti na vašu adresu e-pošte.",
    "You've been gifted a {duration}-month {tierName} membership_one": "",
    "You've been gifted a {duration}-month {tierName} membership_few": "",
    "You've been gifted a {duration}-month {tierName} membership_other": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_few": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a {duration}-year {tierName} membership": "",
    "You've been gifted a {duration}-year {tierName} membership to {siteTitle}": "",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Uspješno ste prijavljeni.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Uspješno ste pretplaćeni na <strong>{siteTitle}</strong>",
    "Your account": "Vaš korisnički račun",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Ponovna pretplata nije uspjela, pokušajte ponovno",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Vaš doprinos pomaže u oblikovanju sadržaja kojeg objavljujemo.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Vaša pretplata istječe {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Vaša pretplata će se obnoviti {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Vaša pretplata će početi {subscriptionStart}"
}
